<span class="text-dark pt-1 me-2">
  {{ 'shift_timeline.all_unselected' | translate }}
</span>
<button nz-button [nzType]="'default'" (click)="handleClick()">
  {{ 'general.undo' | translate }}
</button>
